class SubscriptionWidget {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.subscribeRadio = document.getElementById(`subscribe-option-${sectionId}`);
    this.onetimeRadio = document.getElementById(`onetime-option-${sectionId}`);
    this.frequencySection = document.getElementById(`frequency-section-${sectionId}`);
    this.sellingPlanInput = document.getElementById(`selling-plan-input-${sectionId}`);
    this.frequencyToggle = this.frequencySection?.querySelector('.subscription-widget__frequency-toggle');
    this.frequencyDropdown = this.frequencySection?.querySelector('.subscription-widget__frequency-dropdown');
    this.frequencyOptions = this.frequencySection?.querySelectorAll(`input[name="selling-plan-${sectionId}"]`);
    this.selectedFrequencyText = document.getElementById(`selected-frequency-${sectionId}`);
    
    this.productForm = document.getElementById(`product-form-${sectionId}`);
    this.variantIdInput = this.productForm?.querySelector('input[name="id"]');
    this.currentVariantPrice = 0;
    this.discountPercent = this.getDiscountPercent();
    
    this.setupButtonStructure();
    this.init();
  }
  
  init() {
    if (!this.subscribeRadio || !this.onetimeRadio) return;
    
    this.subscribeRadio.addEventListener('change', () => this.updatePurchaseOption());
    this.onetimeRadio.addEventListener('change', () => this.updatePurchaseOption());
    
    if (this.frequencyToggle) {
      this.frequencyToggle.addEventListener('click', () => this.toggleFrequencyDropdown());
    }
    
    if (this.frequencyOptions) {
      this.frequencyOptions.forEach(option => {
        option.addEventListener('change', (e) => this.selectFrequency(e.target));
      });
    }
    
    if (this.variantIdInput) {
      this.watchVariantChanges();
    }
    
    this.watchQuantityChanges();
    this.watchButtonChanges();
    
    document.addEventListener('click', (e) => this.handleOutsideClick(e));
    
    this.updatePurchaseOption();
  }
  
  setupButtonStructure() {
    const button = this.productForm?.querySelector('.product-form__submit');
    if (!button) {
      console.warn('⚠️ Add to cart button not found');
      return;
    }
    
    const buttonLabel = button.querySelector('.button__label');
    if (!buttonLabel) {
      console.warn('⚠️ Button label not found');
      return;
    }
    
    const existingPriceElement = buttonLabel.querySelector('.button__label-price');
    if (existingPriceElement) {
      console.log('✅ Button structure already exists');
      this.buttonPriceElement = existingPriceElement;
      
      if (existingPriceElement.dataset.variantPrice) {
        this.currentVariantPrice = parseInt(existingPriceElement.dataset.variantPrice);
        console.log('   Stored price:', this.currentVariantPrice);
      }
      
      return;
    }
    
    const currentText = buttonLabel.textContent.trim();
    console.log('Setting up button, text:', currentText);
    
    const priceMatch = currentText.match(/[-–]\s*(£[\d,]+\.?\d*)/);
    
    if (priceMatch) {
      const fullPriceText = priceMatch[0].trim();
      const priceOnly = priceMatch[1];
      const labelText = currentText.replace(fullPriceText, '').trim();
      
      const priceValue = parseFloat(priceOnly.replace('£', '').replace(',', ''));
      const priceInCents = Math.round(priceValue * 100);
      
      this.currentVariantPrice = priceInCents;
      
      console.log('Extracted price:', priceOnly, '=', priceInCents, 'cents');
      
      buttonLabel.innerHTML = `
        <span class="button__label-text">${labelText}</span>
        <span class="button__label-separator"> - </span>
        <span class="button__label-price" data-variant-price="${priceInCents}">${priceOnly}</span>
      `;
      
      this.buttonPriceElement = buttonLabel.querySelector('.button__label-price');
      console.log('✅ Button structure created');
      
    } else if (this.currentVariantPrice > 0) {
      console.log('No price in button, using stored price:', this.currentVariantPrice);
      
      const labelText = currentText.trim();
      const priceText = this.formatMoney(this.currentVariantPrice);
      
      buttonLabel.innerHTML = `
        <span class="button__label-text">${labelText}</span>
        <span class="button__label-separator"> - </span>
        <span class="button__label-price" data-variant-price="${this.currentVariantPrice}">${priceText}</span>
      `;
      
      this.buttonPriceElement = buttonLabel.querySelector('.button__label-price');
      console.log('✅ Button structure restored with stored price');
      
    } else {
      console.warn('⚠️ Could not extract price and no stored price available');
    }
  }
  
  watchButtonChanges() {
    const button = this.productForm?.querySelector('.product-form__submit');
    if (!button) return;
    
    let mutationTimeout;
    
    const observer = new MutationObserver(() => {
      clearTimeout(mutationTimeout);
      
      mutationTimeout = setTimeout(() => {
        const buttonLabel = button.querySelector('.button__label');
        const hasPriceStructure = buttonLabel?.querySelector('.button__label-price');
        
        if (buttonLabel && !hasPriceStructure) {
          console.log('⚠️ Button HTML replaced');
          this.setupButtonStructure();
          setTimeout(() => this.updateButtonPrice(), 10);
        }
      }, 50);
    });
    
    observer.observe(button, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  
  getDiscountPercent() {
    const discountBadge = document.querySelector('.subscription-widget__badge');
    if (discountBadge) {
      const discountMatch = discountBadge.textContent.match(/(\d+)%/);
      if (discountMatch) {
        return parseInt(discountMatch[1]);
      }
    }
    return 0;
  }

  getSubscriptionPrice() {
    // Read the pre-calculated subscription price from the widget display
    const widgetPrice = document.querySelector('.subscription-widget__price--subscription');
    if (widgetPrice) {
        const priceText = widgetPrice.textContent.trim();
        const priceMatch = priceText.match(/[\d,]+\.?\d*/);
        if (priceMatch) {
        const priceValue = parseFloat(priceMatch[0].replace(',', ''));
        const priceInCents = Math.round(priceValue * 100);
        console.log(`📖 Read subscription price from widget: ${this.formatMoney(priceInCents)}`);
        return priceInCents;
        }
    }
    
    // Fallback: calculate if widget price not found
    console.warn('⚠️ Could not read from widget, calculating...');
    const priceInPounds = this.currentVariantPrice / 100;
    const discountMultiplier = (100 - this.discountPercent) / 100;
    const subscriptionPriceInPounds = priceInPounds * discountMultiplier;
    return Math.round(subscriptionPriceInPounds * 100);
    }
  
  watchVariantChanges() {
    const observer = new MutationObserver(() => {
      console.log('📦 Variant changed');
      
      setTimeout(() => {
        // ONLY extract price if subscription is NOT active
        if (!this.subscribeRadio?.checked) {
          const button = this.productForm?.querySelector('.product-form__submit .button__label');
          if (button) {
            const buttonText = button.textContent;
            const priceMatch = buttonText.match(/£([\d,]+\.?\d*)/);
            
            if (priceMatch) {
              const priceValue = parseFloat(priceMatch[1].replace(',', ''));
              const newPrice = Math.round(priceValue * 100);
              
              if (newPrice !== this.currentVariantPrice) {
                console.log(`💰 New variant price: ${this.formatMoney(newPrice)}`);
                this.currentVariantPrice = newPrice;
              }
            }
          }
        } else {
          console.log('⏭️ Subscription active, skipping price extraction');
        }
        
        const hasStructure = this.buttonPriceElement && document.body.contains(this.buttonPriceElement);
        if (!hasStructure) {
          this.setupButtonStructure();
        }
        
        this.updateButtonPrice();
      }, 100);
    });
    
    observer.observe(this.variantIdInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }
  
  watchQuantityChanges() {
    const quantityInput = this.productForm?.querySelector('input[name="quantity"]');
    if (!quantityInput) return;
    
    quantityInput.addEventListener('change', () => {
      console.log('🔢 Quantity changed to:', quantityInput.value);
      this.updateButtonPrice();
    });
    
    quantityInput.addEventListener('input', () => {
      console.log('🔢 Quantity input to:', quantityInput.value);
      this.updateButtonPrice();
    });
    
    const quantityButtons = this.productForm?.querySelectorAll('.quantity__button');
    quantityButtons?.forEach(button => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          console.log('🔢 Quantity changed to:', quantityInput.value);
          this.updateButtonPrice();
        }, 50);
      });
    });
  }
  
  updatePurchaseOption() {
    if (this.subscribeRadio.checked) {
      this.frequencySection.style.display = 'block';
      const selectedPlan = this.frequencySection.querySelector(`input[name="selling-plan-${this.sectionId}"]:checked`);
      if (selectedPlan) {
        this.sellingPlanInput.value = selectedPlan.value;
      }
    } else {
      this.frequencySection.style.display = 'none';
      this.sellingPlanInput.value = '';
    }
    this.updateButtonPrice();
  }
  
  toggleFrequencyDropdown() {
    const isExpanded = this.frequencyToggle.getAttribute('aria-expanded') === 'true';
    this.frequencyToggle.setAttribute('aria-expanded', !isExpanded);
    this.frequencyDropdown.hidden = isExpanded;
  }
  
  selectFrequency(option) {
    this.selectedFrequencyText.textContent = option.dataset.planName;
    this.sellingPlanInput.value = option.value;
    this.frequencyDropdown.hidden = true;
    this.frequencyToggle.setAttribute('aria-expanded', 'false');
    this.updateButtonPrice();
  }
  
    updateButtonPrice() {
    if (!this.buttonPriceElement || !document.body.contains(this.buttonPriceElement)) {
        this.setupButtonStructure();
        if (!this.buttonPriceElement) return;
    }
    
    const variantPrice = this.currentVariantPrice;
    
    if (variantPrice === 0) {
        console.warn('⚠️ No variant price available');
        return;
    }
    
    const quantityInput = this.productForm?.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    
    this.buttonPriceElement.dataset.variantPrice = variantPrice;
    
    // Get the button label element (has data-label attribute)
    const buttonLabel = this.productForm?.querySelector('.button__label');
    const labelText = this.buttonPriceElement?.previousElementSibling?.previousElementSibling?.textContent || 'Add to Basket';
    
    if (this.subscribeRadio?.checked && this.sellingPlanInput.value && this.discountPercent > 0) {
        // Read subscription price from widget (matches Shopify's calculation)
        const subscriptionPrice = this.getSubscriptionPrice();
        const totalPrice = subscriptionPrice * quantity;
        const priceFormatted = this.formatMoney(totalPrice);
        
        console.log(`🔄 Subscription: ${priceFormatted} (${quantity} × ${this.formatMoney(subscriptionPrice)})`);
        this.buttonPriceElement.textContent = priceFormatted;
        
        // UPDATE DATA-LABEL FOR ::after ANIMATION
        if (buttonLabel) {
        buttonLabel.setAttribute('data-label', `${labelText} - ${priceFormatted}`);
        }
    } else {
        const totalPrice = variantPrice * quantity;
        const priceFormatted = this.formatMoney(totalPrice);
        
        console.log(`🔄 Regular: ${priceFormatted} (${quantity} × ${this.formatMoney(variantPrice)})`);
        this.buttonPriceElement.textContent = priceFormatted;
        
        // UPDATE DATA-LABEL FOR ::after ANIMATION
        if (buttonLabel) {
        buttonLabel.setAttribute('data-label', `${labelText} - ${priceFormatted}`);
        }
    }
    }
  
  formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return `£${amount}`;
  }
  
  handleOutsideClick(e) {
    if (this.frequencySection && !this.frequencySection.contains(e.target)) {
      if (this.frequencyDropdown) {
        this.frequencyDropdown.hidden = true;
      }
      if (this.frequencyToggle) {
        this.frequencyToggle.setAttribute('aria-expanded', 'false');
      }
    }
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.subscription-widget').forEach(widget => {
    const sectionId = widget.closest('[data-section]')?.dataset.section;
    if (sectionId) {
      new SubscriptionWidget(sectionId);
    }
  });
});